export default class EventBrigde {
  static init(params) {
    return new EventBrigde(params);
  }

  constructor(params) {
    const {
      application,
      onCloseProduct,
      startCallback,
      onIntroComplete,
      onCameraTransitionBegin,
      onCameraTransitionEnd,
      onMouseAptEnter,
      onMouseAptLeave,
      onProductOpen,
      onReturnToFloor,
      onRoomDidUpdate,
      onModeChange,
      onRoomSelected,
    } = params;

    this.application = application;
    this.onCloseProduct = onCloseProduct;
    this.startCallback = startCallback;
    this.onIntroComplete = onIntroComplete;
    this.onCameraTransitionEnd = onCameraTransitionEnd;
    this.onCameraTransitionBegin = onCameraTransitionBegin;
    this.onMouseAptEnter = onMouseAptEnter;
    this.onMouseAptLeave = onMouseAptLeave;
    this.onProductOpen = onProductOpen;
    this.onReturnToFloor = onReturnToFloor;
    this.onRoomDidUpdate = onRoomDidUpdate;
    this.onModeChange = onModeChange;
    this.onRoomSelected = onRoomSelected;

    this.application.on('app:started', () => {
      this.startCallback();
    });

    this.application.on('ui:onReturnToFloor', () => {
      this.onReturnToFloor();
    });

    this.application.on('ui:onRoomDidUpdate', (data) => {
      this.onRoomDidUpdate(data);
    });

    this.application.on('ui:onProductOpen', (data) => {
      this.onProductOpen(data.id, data.type);
    });

    this.application.on('ui:onHotspotClickCloseProduct', () => {
      this.onCloseProduct();
    });

    this.application.on('ui:onModeDidUpdate', () => {
      this.onModeChange();
    });

    this.application.on('ui:RoomSelected', (data) => {
      this.onRoomSelected(data.room);
    });
  }

  destroy() {
    this.application = null;
  }
}
